export const VALID_SCORE = 3;
export const SHOW_NUMBER_OF_QUESTIONS = 5;
export const SURVEY_CUSTOM_FIELD_NAMES = [
  "questionone",
  "questiontwo",
  "questionthree",
  "questionfour",
  "questionfive",
];
export const COUNTRIES_LIST_URL =
  "https://api.sttarter.com/contentsystem/d84d4ec4799ad10fa6f84fd01de40feb/countries";
export const SURVEY_QUESTIONS_URL = "https://api.sttarter.com/contentsystem/";
export const GET_IMAGE_DATA_URL =
  "https://devapi.sttarter.com/sol-qa/signedurl/v1/generate/get/";
export const PUT_IMAGE_DATA_URL =
  "https://devapi.sttarter.com/sol-qa/signedurl/v1/generate/put/";
export const IMAGE_DATA_URL_ORG_NAME = "JOTUNDEMOAPAC2";
export const BASE_URL = "https://devapi.sttarter.com/euintouch/customer/";
export const STTARTER_API = "https://devapi.sttarter.com/euintouch/";
export const RECEIPTS_API_BASE_URL =
  "https://jotun-vn-api-prod.capillarytech.com/receipts/";
export const PAINTERS_API_BASE_URL =
  "https://jotun-vn-api-prod.capillarytech.com/painters/";
export const awsJotunProd = "https://jotun-prod.s3.eu-west-1.amazonaws.com/";
export const awsSttProd = "https://devapi.sttarter.com/isgsoljotun-prod/";
export const awsJotunTest =
  "https://isgsoljotun-test.s3.eu-west-1.amazonaws.com/";
export const awsSttTest = "https://devapi.sttarter.com/sgsoljotun-test/";
